import { Table, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import type { InsurerOrganizationUnit } from 'BrokerTsLib/src/dtos'
import { useMemo } from 'react'

import { OrganizationDiscountTableRow } from './OrganizationDiscountTableRow'

export const OrganizationDiscountsTable = ({
  insurers,
  isEditDisabled,
  isFetching,
}: {
  insurers: InsurerOrganizationUnit[]
  isEditDisabled?: boolean
  isFetching?: boolean
}) => {
  const sortedInsurers = useMemo(
    () => insurers.slice().sort((a: InsurerOrganizationUnit, b: InsurerOrganizationUnit) => a.insurer.localeCompare(b.insurer)),
    [insurers],
  )

  return (
    <Table sx={{ boxShadow: 'card' }}>
      <Thead>
        <Tr>
          <Th w={1}></Th>
          <Th w={250}>Pojišťovna</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {sortedInsurers.map((insurer: InsurerOrganizationUnit) => (
          <OrganizationDiscountTableRow
            key={insurer.insurerId}
            insurer={insurer}
            isEditDisabled={isEditDisabled}
            isFetching={isFetching}
          />
        ))}
      </Tbody>
    </Table>
  )
}
